import QueryInput from "src/components/QueryInput";
import TransactionsGrid from "src/components/TransactionsGrid/TransactionsGrid";
import { useDataTableState } from "src/hooks/useDataTableState";
import { Product } from "src/models/ProductModel";
import { useGetProductsQuery } from "src/store/apis/Products";
import { columns, config } from "./columns";

export default function ProductsPage() {
  const {
    currentPage,
    setCurrentPage,
    setFilters,
    setFilterQuery,
    queryInputRef,
    dataColumns,
    filterString,
    itemsPerPage,
  } = useDataTableState<Product>({
    columns,
    config,
  });

  const { data, isLoading, isFetching, refetch } = useGetProductsQuery(
    {
      pageNumber: currentPage,
      pageSize: itemsPerPage,
      filter: filterString,
    },
    { refetchOnMountOrArgChange: true },
  );

  return (
    <TransactionsGrid
      onFilterChange={setFilters}
      rowKey="offerId"
      columns={dataColumns}
      dataSource={data?.result?.items ?? []}
      isLoading={isLoading || isFetching}
      refetch={refetch}
      currentPage={currentPage}
      onChangePage={setCurrentPage}
      totalItems={data?.result?.paginator?.totalItems ?? 0}
      prefixNode={
        <QueryInput
          ref={queryInputRef}
          onSearch={(query) => {
            refetch();
            setFilterQuery(query);
          }}
          options={columns.map((col) => ({
            label: col.key,
            value: col.key,
          }))}
        />
      }
    />
  );
}